import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const ROL_LABEL = {
  primeros_pasos: 'Primeros pasos',
  general: 'General',
  recepcionista: 'Recepcionista',
  medico: 'Médico',
  administrador: 'Administrador',
  paciente: 'Paciente',
};

export default function BreadcrumbManual({ rolArticulo, tituloArticulo }) {
  const navigate = useNavigate();

  const crumbs = [
    { label: 'Manual', onClick: () => navigate('/manual') },
    rolArticulo && { label: ROL_LABEL[rolArticulo] || rolArticulo, onClick: () => navigate(`/manual?rol=${rolArticulo}`) },
    tituloArticulo && { label: tituloArticulo, onClick: null },
  ].filter(Boolean);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 3, flexWrap: 'wrap' }}>
      {crumbs.map((c, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <Typography sx={{ color: 'rgba(255,255,255,0.2)', fontSize: 13, mx: 0.25 }}>›</Typography>
          )}
          <Typography
            onClick={c.onClick || undefined}
            sx={{
              fontSize: 13,
              color: c.onClick ? 'var(--c-acento)' : '#90a4ae',
              cursor: c.onClick ? 'pointer' : 'default',
              '&:hover': c.onClick ? { textDecoration: 'underline' } : {},
            }}
          >
            {c.label}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
}
